import React from 'react';

export function Netherlands(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V114H0V0Z" fill="#AE1C28"/>
      <path d="M0 114H513V228H0V114Z" fill="white"/>
      <path d="M0 228H513V342H0V228Z" fill="#21468B"/>
    </svg>
  );
}
